import Accordion from 'components/common/Accordion/Accordion';
import Button from 'components/common/Button';
import ContainerHeader from 'components/common/ContainerHeader';
import React from 'react';
import {useHistory} from 'react-router-dom';
import styled from 'styled-components';
import {colors, containerStyles} from 'styles/shared';

const DocsContainer = styled.div`
  width: 54.4rem;
  height: 56.4rem;
  margin-right: 5rem;
  margin-bottom: 5rem;
  padding: 4.8rem 4.5rem;
  ${containerStyles};
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2.3rem;
`;

const OverrideButton = styled(Button)`
  height: 2.5rem;
  background: ${colors.blue_darker};
  border-radius: 1rem;
  font-size: 1.5rem;
  line-height: 1.8rem;
  color: white;
`;

function DocsSection() {
  let history = useHistory();

  const items = [
    {id: 1, text: 'How do I use my API key?', color: colors.blue_dark},
    {id: 2, text: 'How is billing calculated?', color: colors.green_main},
    {id: 3, text: 'How do I see data for a given country?', color: colors.yellow_main},
    {id: 4, text: 'Where can I find more documentation?', color: colors.purple_main},
    {id: 5, text: 'Where can I use the User Itinerary Service?', color: colors.green_main},
    {id: 6, text: 'I have more questions, where can I contact you?', color: colors.blue_dark, lastItem: true}
  ];

  function redirectToDocs() {
    history.push('/docs');
  }

  function render() {
    return (
      <DocsContainer>
        <Header>
          <ContainerHeader>Quick start documentation</ContainerHeader>

          <OverrideButton width={6.2} isActive={true} onClick={redirectToDocs}>
            View
          </OverrideButton>
        </Header>

        <Accordion items={items} height={37} />
      </DocsContainer>
    );
  }

  return render();
}

export default DocsSection;
